import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import styles from "./StopNavigationDialog.module.scss";

const StopNavigationDialog = ({ visible, onHide, selectedStop, driverLocation }) => {
    const handleOpenInMaps = () => {
        if (selectedStop && driverLocation) {
            const url = `https://maps.google.com/dir/${driverLocation.lat},${driverLocation.lng}/${selectedStop.latitude},${selectedStop.longitude}`;
            window.open(url, "_blank");
        }
        onHide();
    };

    const handleCallClient = () => {
        if (selectedStop) {
            const phoneNumber = selectedStop.phone || selectedStop.clientPhone;
            if (phoneNumber) {
                window.location.href = `tel:${phoneNumber}`;
            }
        }
        onHide();
    };

    const handleSendMessage = () => {
        if (selectedStop) {
            const phoneNumber = selectedStop.phone || selectedStop.clientPhone;
            if (phoneNumber) {
                const message = `Hi ${selectedStop.clientName}, this is your delivery driver. I'm on my way to deliver your package. Please be available at the delivery address.`;
                const url = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;
                window.location.href = url;
            }
        }
        onHide();
    };

    if (!selectedStop) return null;

    return (
        <Dialog visible={visible} onHide={onHide} header="Stop Actions" className={styles.stopNavigationDialog} position="center" modal>
            <div className={styles.navigationContent}>
                <div className={styles.navigationHeader}>
                    <div className={styles.stopInfo}>
                        <h3>{selectedStop.clientName}</h3>
                        <p className={styles.stopEmail}>{selectedStop.email || "No email provided"}</p>
                        <div className={styles.stopAddress}>
                            <i className="pi pi-map-marker" />
                            <span>{selectedStop.address || "Address not available"}</span>
                        </div>
                        {selectedStop.packages && (
                            <div className={styles.packageInfo}>
                                <i className="pi pi-box" />
                                <span>
                                    {selectedStop.packages.length} package{selectedStop.packages.length !== 1 ? "s" : ""}
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                <div className={styles.navigationButtons}>
                    <Button label="Open in Maps" icon="pi pi-map" onClick={handleOpenInMaps} className={`${styles.actionButton} ${styles.primaryButton}`} />

                    <div className={styles.buttonRow}>
                        <Button label="Call" icon="pi pi-phone" severity="success" onClick={handleCallClient} className={styles.actionButton} />

                        <Button label="Message" icon="pi pi-comment" outlined onClick={handleSendMessage} className={styles.actionButton} />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default StopNavigationDialog;
